import { render } from "./CommonSignaturePad.vue?vue&type=template&id=2be01a67"
import script from "./CommonSignaturePad.vue?vue&type=script&lang=js"
export * from "./CommonSignaturePad.vue?vue&type=script&lang=js"

import "./CommonSignaturePad.vue?vue&type=style&index=0&id=2be01a67&lang=scss"

import exportComponent from "C:\\geneuin\\developer\\hwian\\hwian_install_admin_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__